type BasePayload = Partial<Record<PropertyKey, unknown>>;

const elementPayloads = new WeakMap<HTMLElement, BasePayload>();

export function setElementDragAndDropPayload(
	element: HTMLElement,
	payload: BasePayload,
) {
	elementPayloads.set(element, payload);
}

export function getElementDragAndDropPayload<TPayload extends BasePayload>(
	element: HTMLElement,
) {
	const payload = elementPayloads.get(element);
	return payload as TPayload | undefined;
}
